import type { Ref, TextareaHTMLAttributes } from "react";

import { cn } from "./cn";

interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "className"> {
  invalid?: boolean;
  className?: string | undefined;
  /** Нужен полю, которое подгоняет высоту под содержимое. */
  ref?: Ref<HTMLTextAreaElement> | undefined;
}

export function Textarea({ invalid, className, rows = 4, ...rest }: TextareaProps) {
  return (
    <textarea
      {...rest}
      rows={rows}
      className={cn(
        "w-full resize-y rounded-md border bg-surface px-3 py-2 text-sm text-fg",
        "placeholder:text-faint outline-none transition-colors disabled:cursor-not-allowed disabled:opacity-60",
        invalid ? "border-danger" : "border-line focus:border-accent",
        className,
      )}
    />
  );
}
